// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.login-foot span {\n  color: var(--sea);\n  font-size: 0.885rem;\n}\n.login-foot a:hover {\n  color: var(--sea) !important;\n  text-decoration: underline !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
